<template>
  <span>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
            <div class="flex items-center justify-between con-btns-user">
              <div class="flex items-center justify-start con-userx">
                <vs-avatar color="primary" :text="tenant && tenant.Name" />
                <span class="font-semibold text-primary">
                  {{ tenant && tenant.Name }} </span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
          id="profile-tabs" :key="isSmallerScreen">
          <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Company profile' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <tenant-details-view :tenant="tenant" />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-map-pin" :label="!isSmallerScreen ? 'Locations' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <TenantLocations />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-grid" :label="!isSmallerScreen ? 'Buildings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <TenantBuildings />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Contacts' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <TenantContacts />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'Actions' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <TenantActions :company_name="tenant.Name || ''"/>
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'Property Risk Assessments' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <PropertyRiskAssessmentList />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'COPE Assessments' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <CopeAssessmentList />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'Brewery Site Inspections' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <BrewerySiteInspectionList />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'Hazard Inspections' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <HazardInspectionList />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-alert-triangle" :label="!isSmallerScreen ? 'Food Safety Report' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <FoodSafetyReportList />
            </div>
          </vs-tab>

        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import TenantDetailsView from "@/views/pages/tenants/tabs/TenantDetailsView";
import TenantLocations from "@/views/pages/tenants/tabs/TenantLocations";
import TenantBuildings from "@/views/pages/tenants/tabs/TenantBuildings";
import TenantContacts from "@/views/pages/tenants/tabs/TenantContacts";
import PropertyRiskAssessmentList from '@/views/pages/tenants/PropertyRiskAssessmentList.vue'
import CopeAssessmentList from '@/views/pages/tenants/CopeAssessmentList.vue'
import BrewerySiteInspectionList from '@/views/pages/tenants/BrewerySiteInspectionList.vue'
import HazardInspectionList from '@/views/pages/tenants/HazardInspectionList.vue'
import TenantActions from "@/views/pages/tenants/tabs/TenantActions"
import FoodSafetyReportList from '@/views/pages/tenants/FoodSafetyReportList.vue'

const ObjectRepository = RepositoryFactory.get('object')

export default {
  name: "TenantDetailsTabs",
  data() {
    return {
      active_step: this.$route.query.step ? this.$route.query.step : '0',
      tenantId: '',
      tenant: {}
    }
  },
  components: {
    TenantDetailsView,
    TenantLocations,
    TenantBuildings,
    TenantContacts,
    PropertyRiskAssessmentList,
    CopeAssessmentList,
    BrewerySiteInspectionList,
    HazardInspectionList,
    FoodSafetyReportList,
    TenantActions
  },
  async mounted() {
    this.tenantId = this.$route.params.id
    await this.fetchTenant()
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  methods: {
    async fetchTenant() {
      try {
        const { data } = (await ObjectRepository.getObjectDetails('account', this.tenantId)).data;
        this.tenant = data;
        console.log("tenant details", this.tenant)
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  }
}
</script>

<style scoped></style>
